// extracted by mini-css-extract-plugin
export default {"TooltipText":"_TooltipText--kHBsB","Dropdown":"_Dropdown--XdXly","SelectedAlignment":"_SelectedAlignment--cAh_y"};